import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormGroup,
  Box,
  FormHelperText,
  Paper,
  Divider,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { connect } from "react-redux";
import RepeatOrderPatientAutoComplete from "Components/RepeatOrder/RepeatOrderPatientAutoComplete";
import { weeksList } from "utils/data";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  START_CREATE_REPEAT_ORDER,
  START_UPDATE_REPEAT_ORDER,
  START_GET_SINGLE_REPEAT_ORDER,
  RESET_REPEAT_ORDER_STATE,
  START_GET_SEARCH_REPEAT_ORDER,
} from "Actions/RepeatOrderAction";
import { ReactComponent as DeleteIconLined } from "Assets/Icons/DeleteIconLined.svg";
import { ReactComponent as LampIcone } from "Assets/Icons/LampIcone.svg";
import * as yup from "yup";
import { useFormik } from "formik";
import moment from "moment";
import { useNotification } from "Hooks/NotificationManager";
import { useNavigate } from "react-router-dom";
import { ReactComponent as EditIconTwo } from "Assets/Icons/EditIconTwo.svg";
import { ReactComponent as Info } from "Assets/Icons/info.svg";
import { ReactComponent as AddIcon } from "Assets/Icons/AddIcon.svg";
import DrugAutoComplete from "Components/Patients/DrugAutoComplete";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import useViewport from "Hooks/useViewport";
import DrugsDialog from "Components/RepeatOrder/DrugsDialog";
import PRNSeleactionDialog from "Components/RepeatOrder/PRNSeleactionDialog";
import PateintCreateDialog from "Components/RepeatOrder/PateintCreateDialog";
import { getLocalStorage, setLocalStorage } from "utils/generalUtils";
import MultiOrderConfirmationDialog from "Components/OrderPad/MultiOrderConfirmationDialog";
import { useSelector } from "react-redux";
import SubscriptionWaringDailog from "Components/Common/Dialog/SubscriptionWaringDailog";
import clsx from "clsx";
// const DrugsDialog = React.lazy(() =>
//   import("Components/RepeatOrder/DrugsDialog")
// );
// const PRNSeleactionDialog = React.lazy(() =>
//   import("Components/RepeatOrder/PRNSeleactionDialog")
// );
// const PateintCreateDialog = React.lazy(() =>
//   import("Components/RepeatOrder/PateintCreateDialog")
// );

const useStyle = makeStyles((theme) => ({
  PageMain: {
    height: "calc(100vh - 140px)",
    overflowY: "auto",
  },
  rsPatientGridOne: {
    // marginTop: "0px !important",
    "&>div": {
      // paddingLeft: "12px !important",
      "&>h3": {
        fontSize: "20px !important",
      },
      "&>hr": {
        backgroundColor: theme.palette.background.grey,
        marginTop: "10px",
      },
      [theme.breakpoints.down("769")]: {
        // marginLeft: "10px",
      },
    },
  },
  reRepeatOrder: {
    // padding: "17px 13px 25px",
    padding: "10px 13px 15px",
    // padding: "10px 13px 4px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    marginBottom: "20px",
    [theme.breakpoints.down("900")]: {
      marginBottom: "14px",
    },
    [theme.breakpoints.down("768")]: {
      marginBottom: "0px",
    },
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "10px",
      color: "black",
    },
    "&>div": {
      "&>h4": {
        marginBottom: "5px",
        fontSize: "19px !important",
        fontWeight: "500",
        color: "black !important",
        fontFamily: "Poppins !important",
      },
      "&>div": {
        marginBottom: "5px",
        "&>div": {
          "&>label": {
            "&>span:nth-child(2)": {
              // color:"black"
            },
          },
          "&>div": {
            "&>div": {
              "&>button": {
                zIndex: "1",
                background: "white",
                width: "40px",
                borderRadius: "0px",
                height: "30px",
                marginRight: "-12.5px",
                // marginRight: "-13px",
                "&:hover": {
                  background: "white",
                },
              },
            },
          },
        },
      },
    },
    "&>hr": {
      paddingTop: "0px",
      marginBottom: "10px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  reRepeatOrderSmall: {
    // padding: "17px 13px 25px",
    padding: "10px 13px 0px",
    // padding: "10px 13px 4px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    marginBottom: "20px",
    [theme.breakpoints.down("768")]: {
      marginBottom: "0px",
    },
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "10px",
      color: "black",
    },
    "&>div": {
      "&>h4": {
        marginBottom: "5px",
        fontSize: "19px !important",
        fontWeight: "500",
        color: "black !important",
        fontFamily: "Poppins !important",
      },
      "&>div": {
        marginBottom: "5px",
        "&>div": {
          "&>label": {
            "&>span:nth-child(2)": {
              // color:"black"
            },
          },
          "&>div": {
            "&>div": {
              "&>button": {
                zIndex: "1",
                background: "white",
                width: "40px",
                borderRadius: "0px",
                height: "30px",
                marginRight: "-12.5px",
                // marginRight: "-13px",
                "&:hover": {
                  background: "white",
                },
              },
            },
          },
        },
      },
    },
    "&>hr": {
      paddingTop: "0px",
      marginBottom: "10px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  reRepeatOrderChoosePateint: {
    padding: "10px 13px",
    height: "190px",
    // height: "253px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    marginLeft: "10px",
    [theme.breakpoints.down("1200")]: {
      marginLeft: "0px !important",
    },
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "10px",
      color: "black",
    },
    "&>hr": {
      paddingTop: "0px !important",
      marginBottom: "20px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsPatientMedicationBtn: {
    padding: "17px 13px 0px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: "none !important",
    marginBottom: "30px",
    marginLeft: "10px",
    marginTop: "100px",
    "&>div": {
      "&>div": {
        "&>div": {
          "&>div": {
            "&>button": {
              padding: "8px 13px !important",
            },
          },
        },
      },
    },
  },
  rsPatientCancelBtn: {
    marginRight: "30px !important",
    // fontSize: "14px !important",
    // fontWeight: "400 !important",
    borderRadius: "5px !important",
    // marginBottom: "50px !important",
    borderRadius: "5px !important",
    // height: "37px !important",
    // minWidth: "85px !important",
    height: "48px !important",
    minWidth: "120px !important",
  },
  tableBody: {
    "&>div": {
      "&>div": {
        "&>div": {
          "&>label": {
            "&>span": {
              padding: "5px",
            },
          },
        },
      },
    },
    "&>td": {
      marginBottom: "50px !important",
      padding: "10px 20px !important",
      borderBottom: `none !important`,
    },
  },
  info: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    "&>p": {
      // color:"black"
    },
  },
  infoIcon: {
    marginTop: "6px",
    "&>svg": {
      width: "18px",
    },
  },
  rsPatientCreateBtn: {
    whiteSpace: "nowrap",
    margin: "10px !important",
  },
  rsAddMedicationBtn: {
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)  !important",
      border: "none  !important",
      height: "35px !important",
      padding: "8px 8px !important",
      // textTransform: "uppercase !important",
      [theme.breakpoints.down("800")]: {
        padding: "8px 5px !important",
      },
      "&>span": {
        marginLeft: "0px !important",
        "&>svg": {
          // width: "30px !important",
          // height: "17px !important",
          "&>path": {
            fill: "#5A687290 !important",
          },
        },
      },
    },
    // textTransform: "uppercase !important",
    border: "1px solid #7bbd4b  !important",
    backgroundColor: "#7bbd4b  !important",
    color: "#fff !important",
    padding: "8px 11px !important",
    fontWeight: "600 !important",
    "&>span": {
      marginLeft: "0px !important",
      "&>svg": {
        // width: "30px !important",
        // height: "17px !important",
        "&>path": {
          fill: "#fff !important",
          // stroke: "#fff !important",
        },
      },
    },
    borderRadius: "5px !important",
    height: "35px !important",
  },

  rsNumberMedication: {
    marginLeft: "57px !important",
    [theme.breakpoints.down("901")]: {
      marginLeft: "0px !important",
    },
  },
  rsbtnSmallScreen: {
    "&>div": {
      "&>button": {
        marginLeft: "0px !important",
      },
    },
  },
  rsTextField: {
    // marginBottom: "13px !important",
    width: "85px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: "-12px",
    },
  },
  rsTextFieldQuantity: {
    width: "60px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: "-12px",
    },
  },
  rsDrugAutoCompleteBox: {
    // marginBottom: "13px !important",
    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      padding: "7.5px 6px 7.5px 6px !important",
      [theme.breakpoints.down("1300")]: {
        paddingRight: "0px !important",
      },
    },
    "& .MuiFormHelperText-root.Mui-error": {
      marginTop: "3px !important",
    },
  },
  rsPatientBtn: {
    backgroundColor: "#7bbd4b !important",
    whiteSpace: "nowrap",
    height: "35px !important",
    borderRadius: "6px !important",
    // textTransform: "uppercase !important",
    fontWeight: "600 !important",
    "&>span": {
      marginLeft: "-1px",
      marginBottom: "4px",
    },
    "&:disabled": {
      backgroundColor: "grey !important",
      height: "35px !important",
      borderRadius: "6px !important",
    },
    [theme.breakpoints.down("901")]: {
      marginBottom: "10px !important",
      whiteSpace: "nowrap !important",
    },
  },
  rsMediValue: {
    // marginTop: "10px !important",
    // paddingRight: "13px",
    [theme.breakpoints.down("700")]: {
      overflowX: "auto",
    },
    "&>table": {
      borderBottom: "1px solid #e0e0e0 !important",
      borderRight: "1px solid #e0e0e0 !important",
      "&>thead": {
        "&>tr": {
          "&>th": {
            padding: "10px 16px",
            borderTop: "1px solid #e0e0e0 !important",
            borderRight: "0px !important",
          },
        },
      },
      "&>tbody": {
        "&>tr": {
          "&>td": {
            borderRight: "0px !important",
          },
        },
      },
      [theme.breakpoints.down("700")]: {
        minWidth: "750px",
        overflowX: "auto",
      },
    },
  },
  orderCheckBox: {
    padding: "0px 9px !important",
  },
  rsbuttonPrn: {
    "&>div": {
      "&>label": {
        "&>span": {
          padding: "5px",
        },
        "&>button": {
          display: "none",
          fontSize: "14px !important",
          height: "30px !important",
          minWidth: "150px",
        },
        "&>div": {
          "&>button": {
            fontSize: "14px !important",
            height: "30px !important",
            minWidth: "150px",
          },
        },
      },
    },
    "&:hover": {
      "&>div": {
        "&>label": {
          "&>button": {
            display: "flex",
          },
          "&>div": {
            "&>button": {
              display: "none",
            },
          },
        },
      },
    },
  },
  formvalue: {
    "&>div:nth-child(1)": {
      "&>label:nth-child(2)": {
        marginLeft: "0px !important",
      },
      "&>label:nth-child(3)": {
        marginLeft: "-5px !important",
      },
    },
    "&>label": {
      "&>span": {
        fontSize: "16px !important",
        fontWeight: "400 !important",
        // color: "#747474 !important",
        fontFamily: "Poppins",
        color: "black !important",
        "&.MuiFormControlLabel-label": {
          color: "#747474 !important",
        },
      },
    },
  },
  formvalueSmall: {
    "&>div:nth-child(1)": {
      "&>label:nth-child(2)": {
        marginLeft: "0px !important",
      },
      "&>label:nth-child(3)": {
        marginLeft: "-5px !important",
      },
    },
    "&>div": {
      "&>label": {
        "&>span": {
          fontSize: "0.913rem !important",
        },
      },
    },
    "&>label": {
      "&>span": {
        fontSize: "16px !important",
        fontWeight: "400 !important",
        fontFamily: "Poppins",
        color: "black !important",
        "&.MuiFormControlLabel-label": {
          color: "#747474 !important",
        },
      },
    },
  },
  quantity: {
    // marginLeft: "10px !important",
    "&>div": {
      "&>label": {
        fontSize: "9px !important",
      },
    },
  },
  generalInformation: {
    marginLeft: "10px !important",
    paddingLeft: "12px !important",
    [theme.breakpoints.down("768")]: {
      marginLeft: "10px !important",
    },
    "&>div": {
      "&>div": {
        "&>div": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          "&>div": {},
        },
      },
    },
    // maxWidth: "calc(24vw + 10px)"
    // width: "30%"
  },
  // medicineDetails:{
  //   maxWidth: "calc(37vw + 10px)"
  // }
  medicineContainer: {
    paddingLeft: "12px !important",
    // width: "45%",
    [theme.breakpoints.down("900")]: {
      paddingLeft: "28px !important",
      paddingTop: "0px !important",
    },
    [theme.breakpoints.down("800")]: {
      width: "100%",
      marginTop: "10px",
    },
    [theme.breakpoints.down("769")]: {
      width: "100%",
      paddingTop: "12px !important",
    },
    "&>div:nth-child(1)": {
      maxHeight: "calc(71vh + 125px)",
      overflow: "auto",
      borderRadius: "10px",
      paddingBottom: "20px",
      [theme.breakpoints.down("1830")]: {
        maxHeight: "calc(69vh + 90px)",
      },
      "@media (max-height: 750px)": {
        maxHeight: "calc(67vh + 90px)",
      },
      // [theme.breakpoints.down("1830")]: {
      //   maxHeight: "calc(71vh + 115px)",
      // },
    },
  },
  rsPatientPaperGeneralInfoMedi: {
    paddingTop: "0px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    "&>div": {
      "&>div": {
        "&>table": {},
      },
    },
  },
  titleMain: {
    paddingTop: "10px !important",
  },
  rsTitleMedication: {
    position: "sticky",
    top: "0px",
    background: "white",
    zIndex: "10",
    paddingTop: "10px",
    "&>div": {
      "&>button": {
        padding: "8px 8px !important",
      },
      "&>div": {
        "&>button": {
          padding: "8px 13px !important",
        },
        // overflow: "hidden",
        [theme.breakpoints.down("800")]: {
          overflow: "unset",
        },
        "&>div": {
          "&>div": {
            "&>label": {
              fontSize: "9px !important",
            },
            "&>div": {
              "&>div": {
                background: "white",
                zIndex: "2",
              },
            },
          },
          "&>label": {
            zIndex: "1",
          },
        },
      },
      "&>h3": {
        // fontSize: "23px !important",
        fontSize: "19px !important",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("800")]: {
          fontSize: "18px !important",
        },
        fontWeight: "500 !important",
        fontFamily: "Poppins",
        // marginBottom: "10px",
        color: "black !important",
      },
      "&>hr": {
        backgroundColor: theme.palette.background.grey,
        // marginBottom: "20px",
      },
    },
    "&>div:nth-child(3)": {
      "&>div": {
        "&>label": {
          "&>span:nth-child(2)": {
            color: "black !important",
          },
          "&>span": {
            fontWeight: "500",
            padding: "3px !important",
          },
        },
      },
    },
  },
  medicineHr: {
    "&>hr": {
      marginTop: "20px",
      marginBottom: "20px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  submitSection: {
    marginTop: "calc(100vh - 800px) !important",
    width: "-webkit-fill-available !important",
    marginLeft: "0px !important",
    [theme.breakpoints.between("900", "1200")]: {
      position: "relative",
      bottom: "0px",
      marginTop: "10px !important",
    },
    [theme.breakpoints.between("768", "900")]: {
      position: "relative",
      bottom: "0px",
      marginTop: "10px !important",
      display: "flex !important",
      justifyContent: "center",
    },
    [theme.breakpoints.down("800")]: {
      position: "relative",
      bottom: "0px",
      marginBottom: "30px !important",
      marginTop: "30px !important",
    },
  },
  submitSectionSmall: {
    marginTop: "-1px !important",
    width: "-webkit-fill-available !important",
    marginLeft: "0px !important",
    [theme.breakpoints.between("800", "1200")]: {
      position: "relative",
      bottom: "0px",
      marginTop: "-7px !important",
    },
    [theme.breakpoints.down("800")]: {
      position: "relative",
      bottom: "0px",
      marginBottom: "30px !important",
      marginTop: "30px !important",
    },
  },
  rsSubmittBtn: {
    borderRadius: "5px !important",
    // height: "37px !important",
    // width: "95px !important",
    height: "48px !important",
    width: "120px !important",
    // textTransform: "uppercase !important",
    fontWeight: "600 !important",
  },
  generalInfoField: {
    marginRight: "20px !important",
    overflow: "visible !important",
    "&>div": {
      "&>p": {
        marginRight: "0px !important",
        marginLeft: "0px !important",
        width: "250px",
      },
    },
  },
  rsPatientEditContainer: {
    // marginLeft: "5px",
    "&>button": {
      padding: "8px 13px !important",
    },
  },
  choosePateintContainer: {
    paddingLeft: "12px !important",
    [theme.breakpoints.down("1200")]: {
      marginLeft: "10px !important",
    },
    [theme.breakpoints.down("769")]: {
      marginTop: "20px !important",
    },
  },
  LastOrderdate: {
    display: "flex",
    width: "63%",
    justifyContent: "end ",
    marginTop: "5px",
    marginBottom: "-25px",
    "&>h6": {
      color: "#7BC044 !important",
      fontWeight: "600 !important",
      fontSize: "14px !important",
      marginRight: "5px !important",
    },
    "&>h5": {
      color: "#262626 !important",
      fontWeight: "400 !important",
      fontSize: "14px !important",
    },
  },
  LastOrderdateRes: {
    display: "flex",
    justifyContent: "end ",
    marginTop: "5px",
    marginBottom: "-25px",
    "&>h6": {
      color: "#7BC044 !important",
      fontWeight: "600 !important",
      fontSize: "14px !important",
      marginRight: "5px !important",
    },
    "&>h5": {
      color: "#262626 !important",
      fontWeight: "400 !important",
      fontSize: "14px !important",
    },
  },
  rsPrncheck: {
    whiteSpace: "nowrap !important",
  },
  formvalueGrid: {
    display: "grid",
    gridTemplateColumns: "auto auto",
    gridGap: "10px",
  },
}));
const OrderCreateAndUpdateMain = (props) => {
  const classes = useStyle();
  const {
    createRepeatOrderAction,
    createRepeatOrderData,
    updateRepeatOrderAction,
    updateRepeatOrderData,
    getSingleRepeatOrderAction,
    singleRepeatOrder,
    getSearchRepeatOrderAction,
    searchRepeatOrder,
    resetRepeatOrderState,
  } = props;
  const formState = {
    patient_id: "",
    weeks: "",
    order_date: "",
    medication_date: "",
    notes: "",
    medication: [],
    new_medication: [],
    week_other: 0,
    number_of_medication: "",
  };
  const navigate = useNavigate();
  const notification = useNotification();
  const [repeatOrderData, setRepeatOrderData] = useState(formState);
  const [selectedPatientInfo, setSelectedPatientInfo] = useState({});
  const [showWholeForm, setShowWholeForm] = useState(false);
  const [medications, setMedications] = useState([]);
  const [createDrug, setCreateDrug] = useState(false);
  const [isOpenPRNConformation, setIsOpenPRNConformation] = useState(false);
  const [formPayload, setFormPayload] = useState({});
  const [isOpenOrderDate, setIsOpenOrderDate] = React.useState(false);
  const [isOpenMedicationDate, setIsOpenMedicationDate] = React.useState(false);
  const [checkAllAction, setCheckAllAction] = useState(false);
  const [
    isOpenNewPatientRepeatOrderPopup,
    setIsOpenNewPatientRepeatOrderPopup,
  ] = useState(false);
  const [listOpen, setListOpen] = useState(false);
  const [orderActionType, setOrderActionTypeActionType] = useState("");
  const [isMultiOrder, setIsMultiOrder] = useState("");
  const [createMultiOrder, setCreateMultiOrder] = useState(false);
  const [firstSubmitClick, setFirstSubmitClick] = useState(false);
  const blankMediation = medications.filter((item) => {
    return item?.name?.trim() === "";
  });
  const { loginUserDetail } = useSelector((state) => state.user);
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const medicationRef = React.useRef(null);
  const quantityRef = React.useRef(null);
  const { width } = useViewport();
  const { height } = useViewport();
  let OrderList = [];

  if (loginUserDetail?.data?.data?.role === "nursing") {
    OrderList = [
      {
        item: "Order review required",
        type: "slow",
        title: `${" Order review allows you to choose"}\r\n ${" the PRN items before the order is placed. This works best"}
        \r\n ${"for patients whose medication requirements change from order to order."}`,
      },
    ];
  } else {
    OrderList = [
      {
        item: "Order review not required",
        type: "quick",
        title: `${"Order review not required is for patients who need"}\r\n${" the same medication every time an order is placed."}`,
      },
      {
        item: "Order review required",
        type: "slow",
        title: `${" Order review allows you to choose"}\r\n ${" the PRN items before the order is placed. This works best"}
        \r\n ${"for patients whose medication requirements change from order to order."}`,
      },
    ];
  }

  const [order, setOrder] = useState("slow");
  const [showRxSpanManualAddOption, setShowRxSpanManualAddOption] =
    useState(false);

  const query = new URLSearchParams(window.location.search);
  const redirectToPatientList = () => {
    navigate("/order");
  };
  /** return action ticked medication array filter */
  const medicationActionCheck = medications.filter((item) => {
    return item.action === true;
  });

  /** Medication Date validation function */
  const medicationValidation = (medicationDate, orderDate) => {
    let isValid = true;
    let errorMessage = "";
    if (
      query.get("actionType") === "create" &&
      moment(medicationDate).isBefore(moment(new Date(new Date() - 86400000)))
    ) {
      isValid = false;
      errorMessage =
        "The next medication start date should be after the order date.";
    } else if (medicationDate && !moment(orderDate).isBefore(medicationDate)) {
      isValid = false;
      errorMessage =
        "The next medication date must be a date after order date.";
    }
    return {
      isValid,
      errorMessage,
    };
  };

  /** Validation schema */
  const repeatOrderSchema = yup.object().shape({
    order_date: yup
      .string()
      .nullable()
      .required("The next order date field is required."),
    medication_date: yup
      .string()
      .nullable()
      .test("test-name", function (value) {
        const validation = medicationValidation(value, this.parent.order_date);
        if (!validation.isValid) {
          return this.createError({
            path: this.path,
            message: validation.errorMessage,
          });
        } else {
          return true;
        }
      }),
    weeks: yup.string().nullable(true).required("The rx days field is required."),
    number_of_medication: yup
      .number()
      .nullable(true)
      .min(1, "The number must must be greater than 0."),
  });

  /** validate drug */
  const validateDrug = (validationCheckFor = "submit") => {
    if (validationCheckFor === "onChange") {
      const _validateMedication = medications?.map((item) => {
        return (item = {
          ...item,
          errors: {
            name: "",
            quantity: "",
          },
        });
      });
      setMedications(_validateMedication);
      return 0;
    }

    let errorCounter = 0;
    const _validateMedication = medications?.map((item) => {
      if (validationCheckFor === "add") {
        if (item.name.trim() === "" || item.quantity == "") {
          errorCounter++;
        }
      } else {
        item.errors = {
          name: "",
          quantity: "",
        };

        if (item.name.trim() === "" && item.quantity !== "") {
          errorCounter++;
          item.errors.name = "Please enter medication";
        } else if (item.name.trim() !== "") {
          // if (item.quantity == "") {
          //   errorCounter++;
          //   item.errors.quantity = "Please enter quantity";
          // } else
          if (item.quantity && item.quantity <= 0) {
            errorCounter++;
            item.errors.quantity = "The quantity  must be greater than 0.";
          }
          //  else if (isNaN(item.quantity)) {
          //   item.errors.quantity = "The quantity must be a number.";
          //   errorCounter++;
          // }
        }
      }
      return item;
    });
    setMedications(_validateMedication);
    return errorCounter;
  };

  /** Submit function */
  const handleCreateAndEditRepeatOrder = (formValues) => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    if (medicationActionCheck.length > 0 || formValues?.number_of_medication) {
      if (searchRepeatOrder.data.data?.is_multiple_order) {
        if (createMultiOrder) {
          setLocalStorage("prnActive", false);
          /** Validate drugs */
          if (validateDrug() > 0) {
            return false;
          }
          const weeks = parseInt(
            formValues?.weeks === 0
              ? formValues?.week_other
              : formValues?.weeks,
          );
          const payload = {
            patient_id: formValues?.patient_id,
            weeks: weeks,
            is_other_weeks: formValues?.weeks === 0 ? true : false,
            notes: formValues?.notes,
            order_date: moment(new Date(formValues?.order_date)).format(
              "YYYY-MM-DD",
            ),
            order_type: order,
          };
          if (formValues.medication_date) {
            payload.medication_date = moment(
              new Date(formValues?.medication_date),
            ).format("YYYY-MM-DD");
          }
          const checkMedication = medicationActionCheck.length > 0;
          let actionCheckedCounter = 0;
          let _medications = medications;
          if (checkMedication) {
            _medications = _medications.filter((item) => {
              delete item.errors;
              if (item.name.trim() !== "") {
                if (item.action === true) {
                  /** Increment counter */
                  actionCheckedCounter++;
                }
                /** Return only action checked */
                if (item.action === true) {
                  return item;
                }
              }
            });
          } else {
            actionCheckedCounter = 1;
          }
          if (actionCheckedCounter > 0) {
            if (checkMedication) {
              /** If drug not present for patients and mode is create */
              payload.medication = [];
              payload.new_medication = [];
              _medications.map((item) => {
                const { id, name, quantity, changeable_prn } = item;
                if (!item.hasOwnProperty("isNew")) {
                  payload.medication.push({
                    id,
                    changeable_prn,
                  });
                } else {
                  // payload.new_medication = [];
                  payload.new_medication.push({
                    drug_name: name,
                    quantity,
                    changeable_prn: changeable_prn,
                    action: true,
                  });
                }
              });
              //For edit mode only
              if (query.get("actionType") === "edit") {
                let filteredRemovedMedicines = medications
                  .filter((item) => {
                    if (item.name.trim() !== "" && item.action === false) {
                      return item;
                    }
                  })
                  .map((item) => {
                    return item.id;
                  });
                if (filteredRemovedMedicines.length > 0) {
                  payload.delete_medication = filteredRemovedMedicines;
                }
              }
            } else {
              payload.number_of_medication = formValues?.number_of_medication;
            }
            setFormPayload(payload);
            finalSubmitForm(payload);
          } else {
            notification.error("Please select medication");
          }
          setCreateMultiOrder(false);
        } else {
          setIsMultiOrder(true);
        }
      } else {
        setLocalStorage("prnActive", false);
        /** Validate drugs */
        if (validateDrug() > 0) {
          return false;
        }
        const weeks = parseInt(
          formValues?.weeks === 0 ? formValues?.week_other : formValues?.weeks,
        );
        const payload = {
          patient_id: formValues?.patient_id,
          weeks: weeks,
          is_other_weeks: formValues?.weeks === 0 ? true : false,
          notes: formValues?.notes,
          order_date: moment(new Date(formValues?.order_date)).format(
            "YYYY-MM-DD",
          ),
          order_type: order,
        };
        if (formValues.medication_date) {
          payload.medication_date = moment(
            new Date(formValues?.medication_date),
          ).format("YYYY-MM-DD");
        }
        const checkMedication = medicationActionCheck.length > 0;
        let actionCheckedCounter = 0;
        let _medications = medications;
        if (checkMedication) {
          _medications = _medications.filter((item) => {
            delete item.errors;
            if (item.name.trim() !== "") {
              if (item.action === true) {
                /** Increment counter */
                actionCheckedCounter++;
              }
              /** Return only action checked */
              if (item.action === true) {
                return item;
              }
            }
          });
        } else {
          actionCheckedCounter = 1;
        }
        if (actionCheckedCounter > 0) {
          if (checkMedication) {
            /** If drug not present for patients and mode is create */
            payload.medication = [];
            payload.new_medication = [];
            _medications.map((item) => {
              const { id, name, quantity, changeable_prn } = item;
              if (!item.hasOwnProperty("isNew")) {
                payload.medication.push({
                  id,
                  changeable_prn,
                });
              } else {
                // payload.new_medication = [];
                payload.new_medication.push({
                  drug_name: name,
                  quantity,
                  changeable_prn: changeable_prn,
                  action: true,
                });
              }
            });
            //For edit mode only
            if (query.get("actionType") === "edit") {
              let filteredRemovedMedicines = medications
                .filter((item) => {
                  if (item.name.trim() !== "" && item.action === false) {
                    return item;
                  }
                })
                .map((item) => {
                  return item.id;
                });
              if (filteredRemovedMedicines.length > 0) {
                payload.delete_medication = filteredRemovedMedicines;
              }
            }
          } else {
            payload.number_of_medication = formValues?.number_of_medication;
          }
          setFormPayload(payload);
          finalSubmitForm(payload);
        } else {
          notification.error("Please select medication");
        }
      }
    } else {
      notification.error("Please select medication");
    }
    // }
  };
  // /** Final Submit main Function */
  const finalSubmitForm = (payload) => {
    const _payload = payload ? payload : formPayload;
    if (
      query.get("actionType") === "edit" &&
      Object.keys(singleRepeatOrder)?.length > 0
    ) {
      updateRepeatOrderAction(query.get("orderId"), _payload);
    } else {
      createRepeatOrderAction(_payload);
    }
  };

  /** Set handle change for show patient details */
  const handlePatientDetailsChange = (value) => {
    /** If value selected */
    if (value) {
      setMedications([]);
      const newInitialData = {
        ...formState,
        patient_id: value?.id,
      };
      setRepeatOrderData(newInitialData);
      resetForm({ values: newInitialData });
      setShowRxSpanManualAddOption(false);
      setOrder("quick");
      setFirstSubmitClick(false);
      setShowWholeForm(true);
      getSearchRepeatOrderAction(value?.id);
    } else {
      /** If clear */
      setShowWholeForm(false);
      setMedications([]);
      setRepeatOrderData(formState);
      setShowRxSpanManualAddOption(false);
      setOrder("quick");
      setFirstSubmitClick(false);
      resetForm();
    }
  };
  /** handle click add drug  */
  const handleClickAddDrug = () => {
    setMedications(
      medications.concat([
        {
          id: "",
          name: "",
          quantity: "",
          changeable_prn: false,
          action: false,
          errors: {
            name: "",
            quantity: "",
          },
          isNew: true,
        },
      ]),
    );
  };

  /** handle drug change */
  const handleDrugChange = (e, index, rowInfo) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      ...(rowInfo
        ? {
            ...rowInfo,
            meditation_id: rowInfo.id,
          }
        : {
            id: "",
            name: "",
            meditation_id: "",
          }),
    };
    setMedications([...allDrug]);
    validateDrug("onChange");
  };

  /** handle change quantity */
  const handleChangeQuantity = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      quantity: e.target.value,
    };
    setMedications([...allDrug]);
    validateDrug("onChange");
  };

  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    handleBlur,
    resetForm,
    setErrors,
    setFieldValue,
    setTouched,
  } = useFormik({
    initialValues: { ...repeatOrderData },
    validationSchema: repeatOrderSchema,
    enableReinitialize: true,
    onSubmit: handleCreateAndEditRepeatOrder,
  });
  console.log("errors", errors);

  /** Edit list api call */
  useEffect(() => {
    if (
      query.get("actionType") === "edit" &&
      Object.keys(singleRepeatOrder)?.length > 0
    ) {
      setShowWholeForm(true);
      getSingleRepeatOrderAction(query.get("orderId"));
    } else {
      setRepeatOrderData(formState);
    }
  }, []);

  /** Submit patient info call back function */
  const callBackOnSubmitPatientInfo = () => {
    /** List api call */
    getSearchRepeatOrderAction(
      selectedPatientInfo?.patient_id || selectedPatientInfo?.id,
    );
  };

  /** Cancel Call back function */
  const callBackOnCancelPatientInfo = () => {};

  const handleCancel = () => {
    resetForm();
    setRepeatOrderData(formState);
    setSelectedPatientInfo({});
    setShowWholeForm(false);
    setMedications([]);
    setFirstSubmitClick(false);
    setCheckAllAction(false);
    setIsMultiOrder("");
    setCreateMultiOrder(false);
    resetRepeatOrderState("createRepeatOrderData");
    resetRepeatOrderState("updateRepeatOrderData");
    resetRepeatOrderState("singleRepeatOrder");
    resetRepeatOrderState("searchRepeatOrder");
    navigate("/order");
  };

  /** Set edit data useEffect */
  useEffect(() => {
    if (
      query.get("actionType") === "edit" &&
      Object.keys(singleRepeatOrder?.data)?.length > 0
    ) {
      const {
        weeks,
        order_date,
        medication_date,
        patient_medications,
        dob,
        name,
        last_name,
        patient_id,
        order_notes,
        is_other_weeks,
        number_of_medication,
        order_type,
      } = singleRepeatOrder?.data;
      if (is_other_weeks === 1) {
        setShowRxSpanManualAddOption(true);
        setFieldValue("week_other", weeks);
      }
      if (singleRepeatOrder?.data?.group?.is_patient_in_nursing == true) {
        setOrder("slow");
      } else {
        setOrder(order_type);
      }
      setRepeatOrderData({
        patient_id: patient_id,
        weeks: is_other_weeks === 1 ? 0 : weeks,
        order_date: order_date,
        medication_date: medication_date,
        notes: order_notes,
        number_of_medication: number_of_medication,
      });
      setSelectedPatientInfo({
        patient_id,
        name,
        dob,
        last_name,
      });
      const medications = patient_medications.map((item) => {
        item.changeable_prn = item.changeable_prn === 0 ? false : true;
        item.action = item?.is_action;
        return item;
      });
      /**filter duplicate drugs */
      const uniqueMeditation = medications.reduce((accumulator, current) => {
        if (!accumulator.find((item) => item.name === current.name)) {
          accumulator.push(current);
        }
        return accumulator;
      }, []);
      setMedications(uniqueMeditation);
    }
  }, [singleRepeatOrder?.data]);

  /** Search patient success useEffect */
  useEffect(() => {
    if (
      !searchRepeatOrder?.loading &&
      Object.keys(searchRepeatOrder?.data || {})?.length > 0
    ) {
      const { drugs, last_name, name, dob } = searchRepeatOrder.data.data;
      setRepeatOrderData({
        patient_id: searchRepeatOrder.data.data?.id,
        medication_date: "",
        // order_date: searchRepeatOrder.data.data?.order_date
        //   ? searchRepeatOrder.data.data?.order_date
        //   : "",
        order_date: "",
      });
      setSelectedPatientInfo({
        ...selectedPatientInfo,
        last_name,
        name,
        dob,
      });
      const actionedCheckedMedications =
        medicationActionCheck?.map((item) => item.id) || [];
      const manipulateDrugs = drugs?.map((item) => {
        item.action = actionedCheckedMedications.includes(item.id);
        return item;
      });
      /**filter duplicate drugs */
      const uniqueMeditation = manipulateDrugs.reduce(
        (accumulator, current) => {
          if (!accumulator.find((item) => item.name === current.name)) {
            accumulator.push(current);
          }
          return accumulator;
        },
        [],
      );
      setMedications(uniqueMeditation);
    }
  }, [searchRepeatOrder]);

  /** Create & edit order loading  true useEffect */
  useEffect(() => {
    if (
      (!createRepeatOrderData?.loading &&
        Object.keys(createRepeatOrderData?.data || {})?.length > 0) ||
      (!updateRepeatOrderData?.loading &&
        Object.keys(updateRepeatOrderData?.data || {})?.length > 0)
    ) {
      if (getLocalStorage("prnActive") == "false") {
        resetForm();
        setShowWholeForm(false);
        setSelectedPatientInfo({});
        /** Fire action to reset redux */
        resetRepeatOrderState("createRepeatOrderData");
        resetRepeatOrderState("updateRepeatOrderData");
        resetRepeatOrderState("singleRepeatOrder");
        resetRepeatOrderState("searchRepeatOrder");
        // getHomeListAction();
      }
    }
  }, [createRepeatOrderData, updateRepeatOrderData]);

  /** Create & edit order Success redirect to order page */
  useEffect(() => {
    if (
      createRepeatOrderData?.data?.success === true ||
      updateRepeatOrderData?.data?.success
    ) {
      if (createRepeatOrderData?.data?.success === true) {
        setLocalStorage("refreshRepeatOrderListOnReturn", true);
      }
      if (getLocalStorage("prnActive") == "false") {
        redirectToPatientList();
      }
    }
  }, [
    createRepeatOrderData?.data?.success,
    updateRepeatOrderData?.data?.success,
  ]);

  /** Create & edit order sever side error */
  useEffect(() => {
    const errors =
      query.get("actionType") === "create"
        ? createRepeatOrderData?.error?.errors
        : updateRepeatOrderData?.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        notification.error(value[0]);
        return item;
      });
      setErrors(obj);

      setIsMultiOrder(false);
    }
  }, [createRepeatOrderData?.error, updateRepeatOrderData.error]);
  /** get list  */
  useEffect(() => {
    if (query.get("actionType") === "create") {
      setSelectedPatientInfo({});
    }
  }, []);

  /** handle change action  */
  const handleChangePRN = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      changeable_prn: !allDrug[index]?.changeable_prn,
    };
    setMedications([...allDrug]);
  };

  /** handle change action  */
  const handleChangeAction = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      action: !allDrug[index]?.action,
    };
    setMedications([...allDrug]);
  };

  /** get medication  */
  useEffect(() => {
    const checkAction = medications?.filter((item) => {
      return item.action;
    });
    setCheckAllAction(checkAction?.length === medications?.length);
  }, [medications]);

  /** Susses of submit patient form */
  const onSuccessOfSubmitPatientForm = (responseData) => {
    const data = responseData;
    const { id, name, last_name, dob, status } = data;
    const objPatientInfo = {
      id,
      name,
      last_name,
      dob,
      status,
    };
    setFieldValue("name", name);
    setSelectedPatientInfo(objPatientInfo);
    setFieldValue("patient_id", id);
    setShowWholeForm(true);
    const drugInfo = responseData?.drugs?.map((item) => {
      return item;
    });

    /** remove duplicate medication */
    const uniqueMeditation = drugInfo?.reduce((accumulator, current) => {
      if (!accumulator.find((item) => item.name === current.name)) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    setMedications(uniqueMeditation);
  };
  const handlePatientDailog = () => {
    setIsOpenNewPatientRepeatOrderPopup(true);
  };
  const openNextOrderDatePicker = () => {
    // let flag = searchRepeatOrder.data.data?.group?.is_patient_in_group
    //   ? true
    //   : singleRepeatOrder?.data?.group?.is_patient_in_group
    //   ? true
    //   : false;
    // if (!flag) {
    //   setIsOpenOrderDate(true);
    // } else {
    //   return;
    // }
    setIsOpenOrderDate(true);
  };
  return (
    <Grid className={classes.PageMain}>
      <form
        name="registration"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
          setFirstSubmitClick(true);
          var order_date = document.registration.order_date.value;
          var weeks = document.registration.weeks.value;
          const firstError = Object.keys(errors).reduce((field, a) => {
            return !!errors[field] ? field : a;
          }, null);
          if (order_date === null || order_date === "") {
            document.getElementById("order_date")?.focus();
          } else if (firstError === "order_date") {
            document.getElementById("order_date")?.focus();
          } else if (weeks === null || weeks === "") {
            document.getElementById("weeks")?.focus();
          } else if (firstError === "weeks") {
            document.getElementById("weeks")?.focus();
          } else if (firstError === "order_type") {
            document.getElementById("order_type")?.focus();
          } else if (firstError === "medication_date") {
            document.getElementById("medication_date")?.focus();
          }
          // setTouched({ weeks: true });
          setTimeout(() => {
            const elementType = document.getElementById("order_type");
            if (elementType) {
              // /**Will scroll smoothly to the top of the next section*/
              elementType.scrollIntoView();
            }
          }, 1000);
          const element = document.getElementById("weeks");
          if (element) {
            // /**Will scroll smoothly to the top of the next section*/
            element.focus();
          }
          setTimeout(() => {
            const errorId = ["name", "quantity"];
            let foundError = false;
            for (let i = 0; i <= medications.length; i++) {
              if (foundError) {
                break;
              }
              for (let j = 0; j <= errorId.length; j++) {
                const element = document.getElementById(`${errorId[j]}_${i}`);
                if (
                  element?.parentElement?.nextSibling?.classList?.contains(
                    "Mui-error",
                  )
                ) {
                  element.focus();
                  foundError = true;
                  break;
                }
              }
            }
          }, 1000);
        }}
      >
        <Grid
          container
          columnSpacing={2.5}
          rowSpacing={3}
          className={classes.rsPatientGridOne}
          display={"flex"}
        >
          <Grid item xl={4.5} lg={4.5} md={6} sm={12} xs={12}>
            <Grid
              className={classes.choosePateintContainer}
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              marginBottom={"12px"}
              marginLeft={"0px"}
              paddingLeft={"0px !important"}
            >
              <Paper className={classes.reRepeatOrderChoosePateint}>
                <Typography variant="h3" medium color="secondary">
                  Choose Patient{" "}
                </Typography>
                <Divider />
                <Grid
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"space-between"}
                  height={"-webkit-fill-available"}
                  container
                >
                  <Box item display={"flex"} alignItems={"center"}>
                    <RepeatOrderPatientAutoComplete
                      fullWidth
                      disabled={query.get("actionType") === "edit"}
                      value={selectedPatientInfo}
                      className={classes.autoCompleteBox}
                      onChange={(e, value) => {
                        if (value === null) {
                          /**
                           * set a all filed value null
                           */
                          setFieldValue("patient_id", "");
                          setSelectedPatientInfo({});
                          handlePatientDetailsChange(null);
                          return;
                        }
                        setSelectedPatientInfo(value);
                        setFieldValue("patient_id", value?.id);
                        handlePatientDetailsChange(value);
                      }}
                      buttonOptionTop={true}
                      buttonTitle={"Create New Patient"}
                      handleButtonClick={handlePatientDailog}
                      onBlur={handleBlur}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          autoFocus
                          label="Choose Patient*"
                          error={touched?.patient_id && errors?.patient_id}
                          helperText={touched?.patient_id && errors?.patient_id}
                        />
                      )}
                    />
                  </Box>
                  <Box item className={classes.rsPatientEditContainer}>
                    <Button
                      // className={clsx("BtnGreen", classes.rsPatientBtn)}
                      className={classes.rsPatientBtn}
                      variant="contained"
                      disabled={
                        values.patient_id === ""
                        // values.patient_id === "" ||
                        // (values?.number_of_medication !== "" &&
                        //   medicationActionCheck.length === 0)
                        // values?.number_of_medication !== "" &&
                        // medicationActionCheck.length === 0
                      }
                      startIcon={
                        <PrimaryIcon
                          icon={EditIconTwo}
                          color="white"
                          width="16px"
                          height="16px"
                        />
                      }
                      onClick={() => {
                        setCreateDrug(true);
                      }}
                    >
                      Edit Patient
                    </Button>
                  </Box>
                </Grid>
              </Paper>
            </Grid>

            {showWholeForm &&
              !searchRepeatOrder?.loading &&
              !singleRepeatOrder?.loading && (
                <Grid
                  item
                  className={classes.generalInformation}
                  paddingLeft={"0px !important"}
                  xl={12}
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                >
                  <Paper
                    className={
                      height >= 831
                        ? classes.reRepeatOrder
                        : classes.reRepeatOrderSmall
                    }
                  >
                    <Typography variant="h3" medium color="secondary">
                      Order Frequency
                    </Typography>
                    <Divider />
                    <Box>
                      <Typography color="#747474" variant="h5" id="weeks">
                        Choose a standard option or enter your own number of
                        days.
                      </Typography>
                      <Box
                        className={
                          height > 770
                            ? classes.formvalue
                            : classes.formvalueSmall
                        }
                      >
                        <Grid container>
                          {weeksList?.map((item, index) => {
                            if (
                              (values?.weeks == undefined &&
                                item?.value == 84) ||
                              (values?.weeks != 84 && item?.value == 84)
                            ) {
                              return <></>;
                            } else {
                              return (
                                <Grid
                                  item
                                  className={classes.formvalueGrid}
                                  key={index}
                                >
                                  <FormControlLabel
                                    id="weeks"
                                    value={item?.value}
                                    key={index}
                                    name="weeks"
                                    checked={values?.weeks === item?.value}
                                    onChange={(e, value) => {
                                      if (
                                        query?.get("actionType") === "create"
                                      ) {
                                        if (
                                          item?.value > 0 &&
                                          !values?.order_date
                                        ) {
                                          setIsOpenOrderDate(
                                            (isOpenOrderDate) =>
                                              !isOpenOrderDate,
                                          );
                                        }
                                      }
                                      setFieldValue("weeks", item?.value);
                                    }}
                                    onClick={() => {
                                      if (item?.value === 0) {
                                        setShowRxSpanManualAddOption(true);
                                      } else {
                                        setShowRxSpanManualAddOption(false);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        color="primary"
                                      />
                                    }
                                    label={item?.label}
                                  />
                                </Grid>
                              );
                            }
                          })}
                          {showRxSpanManualAddOption && (
                            <>
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"center"}
                                gap={1}
                              >
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  // label="Please Enter"
                                  placeholder="0"
                                  size="small"
                                  type="number"
                                  name="week_other"
                                  value={values?.week_other}
                                  sx={{
                                    width: "64px",
                                    marginTop: "0px",
                                  }}
                                  // error={touched?.weeks && errors?.weeks}
                                  // helperText={touched?.weeks && errors?.weeks}
                                  onChange={(e) => {
                                    let isNagative = e.target.value <= 0;
                                    if (isNagative) {
                                      e.target.value = 0;
                                    }                                  
                                    let weekListing = weeksList?.filter((item) => item?.value != 84)?.map((item) => {
                                      return item?.value;
                                    });

                                    if (
                                      weekListing.indexOf(
                                        parseInt(e.target.value),
                                      ) === -1
                                    ) {
                                      setFieldValue(
                                        "week_other",
                                        e.target.value,
                                      );
                                      handleChange();
                                    }
                                  }}
                                  onBlur={handleBlur}
                                />
                                <Typography variant="h4" fontSize={"12px"}>
                                  days
                                </Typography>
                              </Box>
                            </>
                          )}
                        </Grid>
                        {firstSubmitClick && errors.weeks && (
                          <Typography
                            color="error"
                            variant="p"
                            fontSize={"12px"}
                            marginBottom={"10px"}
                          >
                            {errors.weeks}
                          </Typography>
                        )}
                      </Box>
                      {/* Custom days info tip box */}
                      {showRxSpanManualAddOption && (
                        <Box
                          display={"flex"}
                          alignItems={"flex-start"}
                          gap={1.2}
                          sx={{
                            backgroundColor: "#7BC0441A",
                            border: "1px solid #50505033",
                            borderRadius: "15px",
                            padding: "10px 14px",
                            marginTop: "8px",
                            marginBottom: "8px !important",
                          }}
                        >
                          <Box
                            sx={{
                              width: "33px",
                              height: "33px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <PrimaryIcon
                              icon={LampIcone}
                              color="white"
                              width="33px"
                              height="33px"
                              small={false}
                            />
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 400,
                              color: "#0F0F0F",
                              lineHeight: 1.5,
                            }}
                          >
                            Enter any number of days (e.g. 26, 27 or 30) to
                            place orders earlier or later than the standard
                            schedule.
                          </Typography>
                        </Box>
                      )}
                      {/* <FormHelperText
                      error={touched?.weeks && errors?.weeks}
                      style={{ marginTop: "-8px" }}
                    >
                      {touched?.weeks && errors?.weeks}
                    </FormHelperText> */}
                    </Box>
                    <Box display={width > 600 ? "flex" : "block"}>
                      {/* <Box display={"flex"}> */}
                      <HtmlTooltipMain
                      // title={
                      //   searchRepeatOrder.data.data?.group
                      //     ?.is_patient_in_group ||
                      //   singleRepeatOrder?.data?.group?.is_patient_in_group
                      //     ? `${"Patient is in a group. To change the order date you must first remove patient from the group."}`
                      //     : ""
                      // }
                      >
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={5}
                          lg={5}
                          className={classes.generalInfoField}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              id="order_date"
                              name="order_date"
                              label="Next Order Date *"
                              views={["year", "month", "day"]}
                              inputFormat="DD-MM-YYYY"
                              open={isOpenOrderDate}
                              onOpen={() => setIsOpenOrderDate(true)}
                              // disabled={
                              //   searchRepeatOrder.data.data?.group
                              //     ?.is_patient_in_group
                              //     ? true
                              //     : singleRepeatOrder?.data?.group
                              //         ?.is_patient_in_group
                              //     ? true
                              //     : false
                              // }
                              onClose={() => setIsOpenOrderDate(false)}
                              value={values?.order_date}
                              onChange={(newDate) => {
                                setFieldValue("order_date", newDate);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  id="order_date"
                                  onClick={() =>
                                    // setIsOpenOrderDate(true)
                                    openNextOrderDatePicker()
                                  }
                                  fullWidth
                                  InputLabelProps={{ shrink: true }} // Ensures label stays above input
                                  size="small"
                                  name="order_date"
                                  {...params}
                                  error={
                                    touched?.order_date && errors?.order_date
                                  }
                                  helperText={
                                    touched?.order_date && errors?.order_date
                                  }
                                  onBlur={handleBlur}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </HtmlTooltipMain>
                      {!showRxSpanManualAddOption && (
                        <Grid item xs={12} sm={12} md={7} lg={7}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              id="medication_date"
                              name="medication_date"
                              disablePast
                              label="Next Medication Start Date (optional)"
                              views={["year", "month", "day"]}
                              inputFormat="DD-MM-YYYY"
                              open={isOpenMedicationDate}
                              onOpen={() => setIsOpenMedicationDate(true)}
                              onClose={() => setIsOpenMedicationDate(false)}
                              minDate={new Date()}
                              value={values?.medication_date}
                              onChange={(newDate) => {
                                setFieldValue("medication_date", newDate);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  id="medication_date"
                                  fullWidth
                                  onClick={() => setIsOpenMedicationDate(true)}
                                  InputLabelProps={{ shrink: true }} // Ensures label stays above input
                                  size="small"
                                  name="medication_date"
                                  {...params}
                                  error={
                                    touched?.medication_date &&
                                    errors?.medication_date
                                  }
                                  helperText={
                                    touched?.medication_date &&
                                    errors?.medication_date
                                  }
                                  onBlur={handleBlur}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                      )}
                    </Box>
                    <Box display={"flex"} flexDirection={"column"}>
                      {OrderList?.map((item, index) => {
                        return (
                          <FormControlLabel
                            className={classes.labelWhiteSpaceNW}
                            value={item}
                            id="order_type"
                            name="order_type"
                            disabled={
                              loginUserDetail?.data?.data?.role !== "nursing" &&
                              (searchRepeatOrder.data.data
                                ?.is_patient_in_nursing ||
                                singleRepeatOrder?.data?.group
                                  ?.is_patient_in_nursing) &&
                              index === 0
                            }
                            key={index}
                            checked={order === item.type}
                            onChange={(e, value) => {
                              setOrder(item.type);
                            }}
                            control={
                              <Checkbox
                                icon={<RadioButtonUncheckedIcon />}
                                checkedIcon={<RadioButtonCheckedIcon />}
                                color="primary"
                              />
                            }
                            label={
                              <Box className={classes.info}>
                                <Typography>{item.item}</Typography>&nbsp;
                                <HtmlTooltipMain title={item.title}>
                                  <Info fontSize="inherit" />
                                </HtmlTooltipMain>
                              </Box>
                            }
                          />
                        );
                      })}
                    </Box>
                    {errors?.order_type && (
                      <FormHelperText
                        error={errors?.order_type}
                        style={{ marginTop: "10px", marginBottom: "20px" }}
                      >
                        {errors?.order_type}
                      </FormHelperText>
                    )}
                  </Paper>
                </Grid>
              )}

            {width > 900 &&
              showWholeForm &&
              !searchRepeatOrder?.loading &&
              !singleRepeatOrder?.loading && (
                <>
                  <Grid
                    container
                    columnSpacing={2.5}
                    rowSpacing={2}
                    className={
                      height >= 831
                        ? classes.submitSection
                        : classes.submitSectionSmall
                    }
                  >
                    {/* <Box display={"flex"} margin={"0 auto"} justifyContent={"center"}> */}
                    {/* <Grid item xs={6} sm={6} md={6} lg={6}> */}
                    <Button
                      variant="outlined"
                      onClick={handleCancel}
                      className={clsx("BtnGray", classes.rsPatientCancelBtn)}
                    >
                      Cancel
                    </Button>
                    {/* </Grid> */}
                    {/* <Grid item xs={6} sm={6} md={6} lg={6}> */}
                    <Button
                      variant="contained"
                      type="submit"
                      className={classes.rsSubmittBtn}
                      disabled={
                        createRepeatOrderData?.loading ||
                        updateRepeatOrderData?.loading ||
                        singleRepeatOrder.loading
                      }
                      startIcon={
                        (createRepeatOrderData?.loading ||
                          updateRepeatOrderData?.loading) && (
                          <CircularProgress color="white" size="20px" />
                        )
                      }
                    >
                      Submit
                    </Button>
                    {/* </Grid> */}
                    {/* </Box> */}
                  </Grid>
                </>
              )}
          </Grid>

          {(searchRepeatOrder?.loading || singleRepeatOrder?.loading) && (
            <Grid
              item
              xl={7.4}
              lg={7.4}
              md={6}
              sm={12}
              xs={12}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              style={{ minHeight: "350px" }}
            >
              <CircularProgress />
              <Typography
                variant="h4"
                style={{ marginTop: "20px", color: "#747474", fontWeight: 400 }}
              >
                {query.get("actionType") === "edit"
                  ? "Loading order details..."
                  : "Loading patient details..."}
              </Typography>
            </Grid>
          )}

          {showWholeForm &&
            !searchRepeatOrder?.loading &&
            !singleRepeatOrder?.loading && (
              <>
                {" "}
                <Grid
                  item
                  className={classes.medicineContainer}
                  xl={7.4}
                  lg={7.4}
                  md={6}
                  sm={12}
                  xs={12}
                >
                  {/* <Grid> */}
                  <Paper
                    elevation={1}
                    className={classes.rsPatientPaperGeneralInfoMedi}
                  >
                    <Grid container>
                      <Grid item xs={12} className={classes.rsTitleMedication}>
                        <Grid
                          position={"sticky"}
                          display={"flex"}
                          justifyContent={"space-between"}
                          width={"-webkit-fill-available"}
                          xs={12}
                        >
                          <Typography variant="h3" medium color="secondary">
                            Medicine details
                          </Typography>
                          <Button
                            className={classes.rsAddMedicationBtn}
                            variant="contained"
                            disabled={
                              values?.number_of_medication ||
                              blankMediation.length > 0
                            }
                            startIcon={
                              <PrimaryIcon
                                icon={AddIcon}
                                color="white"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              setOrderActionTypeActionType("orderCreate");
                              handleClickAddDrug();
                              setListOpen(true);
                              medicationRef?.current?.focus();
                            }}
                          >
                            Add Medicine
                            {/* Add Medicine */}
                          </Button>
                        </Grid>

                        <Grid item xs={12} className={classes.titleMain}>
                          <Divider />
                        </Grid>

                        <Box
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"flex-start"}
                          marginTop={"10px"}
                          marginRight={"10px"}
                          marginLeft={"10px"}
                          // margin={"10px 10px"}
                        >
                          <FormGroup>
                            <FormControlLabel
                              label={"Order All"}
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={checkAllAction}
                                  className={classes.orderCheckBox}
                                  onChange={(e, value) => {
                                    const isChecked = !checkAllAction;
                                    setCheckAllAction(isChecked);

                                    const _medications = medications?.map(
                                      (item) => {
                                        item.action = isChecked;
                                        return item;
                                      },
                                    );
                                    setMedications(_medications);
                                  }}
                                />
                              }
                            />
                          </FormGroup>
                        </Box>
                      </Grid>

                      <Grid item xs={12} className={classes.rsMediValue}>
                        {medications?.map((item, index) => {
                          return (
                            <>
                              <Grid className={classes.tableBody}>
                                <Box
                                  className={
                                    (width < 1200 && width > 900) ||
                                    width <= 500
                                      ? classes.LastOrderdateRes
                                      : classes.LastOrderdate
                                  }
                                >
                                  <Typography variant="h6">
                                    Last ordered:
                                  </Typography>
                                  <Typography variant="h5">
                                    {item?.order_date
                                      ? moment(
                                          new Date(item?.order_date),
                                        ).format("DD-MM-YYYY") || "N / A"
                                      : "-"}
                                  </Typography>
                                </Box>
                                <Grid
                                  display={"flex"}
                                  // flexDirection={width <= 550 ? "column" : "row"}
                                  flexDirection={
                                    (width < 1200 && width > 900) ||
                                    width <= 500
                                      ? "column"
                                      : "row"
                                  }
                                  alignItems={
                                    (width < 1200 && width > 900) ||
                                    width <= 500
                                      ? ""
                                      : "center"
                                  }
                                  // justifyContent={"center"}
                                  marginTop={"20px"}
                                  marginLeft={"10px"}
                                >
                                  {(width > 1200 || width < 900) &&
                                    width > 500 && (
                                      <>
                                        <Grid>
                                          <FormGroup>
                                            <FormControlLabel
                                              // label={"Order"}
                                              control={
                                                <Checkbox
                                                  color="primary"
                                                  checked={
                                                    item?.action
                                                      ? item?.action
                                                      : false
                                                  }
                                                  onChange={(e, value) => {
                                                    handleChangeAction(
                                                      e,
                                                      index,
                                                    );
                                                  }}
                                                />
                                              }
                                            />
                                          </FormGroup>
                                        </Grid>
                                        <Grid
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={7}
                                          marginRight={"30px"}
                                        >
                                          <DrugAutoComplete
                                            listOpen={listOpen}
                                            fullWidth
                                            disabled={!item.isNew}
                                            filterMedication={medications}
                                            className={
                                              classes.rsDrugAutoCompleteBox
                                            }
                                            value={item}
                                            onChange={(e, value) => {
                                              value = value
                                                ? {
                                                    ...value,
                                                    name: value?.label,
                                                  }
                                                : value;
                                              delete value?.label;
                                              handleDrugChange(e, index, value);
                                              handleChange("drug", value);
                                              if (value !== null) {
                                                quantityRef.current.focus();
                                              }
                                            }}
                                            id={`name_${index}`}
                                            orderActionType={orderActionType}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                              <>
                                                <TextField
                                                  {...params}
                                                  inputRef={
                                                    orderActionType ===
                                                    "orderCreate"
                                                      ? medicationRef
                                                      : ""
                                                  }
                                                  autoFocus={
                                                    orderActionType ===
                                                    "orderCreate"
                                                  }
                                                  id={`name_${index}`}
                                                  label="Drug Name"
                                                  placeholder="Choose Drug"
                                                  error={
                                                    item?.errors?.name &&
                                                    item?.errors?.name
                                                  }
                                                  helperText={
                                                    item?.errors?.name &&
                                                    item?.errors?.name
                                                  }
                                                />
                                              </>
                                            )}
                                          />
                                        </Grid>
                                        <Grid
                                          marginRight={"40px"}
                                          // xs={3}
                                          // sm={width > 750 && width < 1000 ? 2.5 : 1.5}
                                          // md={width > 900 && width < 1100 ? 5 : 3}
                                          // lg={2.5}
                                          // xl={width < 1900 ? 1 : 1}
                                          className={classes.quantity}
                                        >
                                          <TextField
                                            variant="outlined"
                                            fullWidth
                                            inputRef={quantityRef}
                                            disabled={!item.isNew}
                                            placeholder="Quantity"
                                            // label="Quantity"
                                            inputProps={{ maxLength: 10 }}
                                            size="small"
                                            value={
                                              item.quantity ? item.quantity : ""
                                            }
                                            name={`medications[${index}]`}
                                            onChange={(e, value) => {
                                              handleChangeQuantity(e, index);
                                              handleChange(e);
                                            }}
                                            id={`quantity_${index}`}
                                            error={
                                              item?.errors?.quantity &&
                                              item?.errors?.quantity
                                            }
                                            helperText={
                                              item?.errors?.quantity &&
                                              item?.errors?.quantity
                                            }
                                            onBlur={handleBlur}
                                            className={
                                              classes.rsTextFieldQuantity
                                            }
                                          />
                                        </Grid>
                                        <Grid
                                          display={"flex"}
                                          alignItems={"center"}
                                        >
                                          <Grid className={classes.rsbuttonPrn}>
                                            <FormGroup>
                                              <FormControlLabel
                                                className={classes.rsPrncheck}
                                                // label="Mark PRN"
                                                label="PRN"
                                                control={
                                                  // <>
                                                  //   {item?.changeable_prn ? (
                                                  //     <Button
                                                  //       variant="contained"
                                                  //       onClick={(e) => {
                                                  //         handleChangePRN(e, index);
                                                  //       }}
                                                  //     >
                                                  //       Mark not PRN
                                                  //     </Button>
                                                  //   ) : (
                                                  //     <Button
                                                  //       variant="outlined"
                                                  //       onClick={(e) => {
                                                  //         handleChangePRN(e, index);
                                                  //       }}
                                                  //     >
                                                  //       Mark PRN
                                                  //     </Button>
                                                  //   )}
                                                  //   <Box>
                                                  //     {item?.changeable_prn ? (
                                                  //       <Button
                                                  //         variant="contained"
                                                  //         onClick={(e) => {
                                                  //           handleChangePRN(e, index);
                                                  //         }}
                                                  //       >
                                                  //         PRN
                                                  //       </Button>
                                                  //     ) : (
                                                  //       <Button
                                                  //         variant="outlined"
                                                  //         onClick={(e) => {
                                                  //           handleChangePRN(e, index);
                                                  //         }}
                                                  //       >
                                                  //         Mark PRN
                                                  //       </Button>
                                                  //     )}
                                                  //   </Box>
                                                  // </>
                                                  <Checkbox
                                                    color="primary"
                                                    checked={
                                                      item?.changeable_prn
                                                        ? item?.changeable_prn ===
                                                          true
                                                        : false
                                                    }
                                                    onChange={(e, value) => {
                                                      handleChangePRN(e, index);
                                                    }}
                                                  />
                                                }
                                              />
                                            </FormGroup>
                                          </Grid>
                                        </Grid>
                                      </>
                                    )}

                                  {((width < 1200 && width > 900) ||
                                    width <= 500) && (
                                    <>
                                      <Grid
                                        display={"flex"}
                                        justifyContent={"flex-start"}
                                      >
                                        <Grid>
                                          <FormGroup>
                                            <FormControlLabel
                                              // label={"Order"}
                                              control={
                                                <Checkbox
                                                  color="primary"
                                                  checked={
                                                    item?.action
                                                      ? item?.action
                                                      : false
                                                  }
                                                  onChange={(e, value) => {
                                                    handleChangeAction(
                                                      e,
                                                      index,
                                                    );
                                                  }}
                                                />
                                              }
                                            />
                                          </FormGroup>
                                        </Grid>
                                        <Grid xs={12} sm={12} md={12} lg={7}>
                                          <DrugAutoComplete
                                            listOpen={listOpen}
                                            fullWidth
                                            disabled={!item.isNew}
                                            filterMedication={medications}
                                            className={
                                              classes.rsDrugAutoCompleteBox
                                            }
                                            value={item}
                                            onChange={(e, value) => {
                                              value = value
                                                ? {
                                                    ...value,
                                                    name: value?.label,
                                                  }
                                                : value;
                                              delete value?.label;
                                              handleDrugChange(e, index, value);
                                              handleChange("drug", value);
                                              if (value !== null) {
                                                quantityRef.current.focus();
                                              }
                                            }}
                                            id={`name_${index}`}
                                            orderActionType={orderActionType}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                              <>
                                                <TextField
                                                  {...params}
                                                  inputRef={
                                                    orderActionType ===
                                                    "orderCreate"
                                                      ? medicationRef
                                                      : ""
                                                  }
                                                  autoFocus={
                                                    orderActionType ===
                                                    "orderCreate"
                                                  }
                                                  id={`name_${index}`}
                                                  label="Drug Name"
                                                  placeholder="Choose Drug"
                                                  error={
                                                    item?.errors?.name &&
                                                    item?.errors?.name
                                                  }
                                                  helperText={
                                                    item?.errors?.name &&
                                                    item?.errors?.name
                                                  }
                                                />
                                              </>
                                            )}
                                          />
                                        </Grid>
                                      </Grid>
                                      <Grid
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={7}
                                        display={"flex"}
                                        justifyContent={"space-between"}
                                      >
                                        <Grid
                                          marginLeft={"46px"}
                                          xs={12}
                                          sm={12}
                                          // md={width > 900 && width < 1100 ? 5 : 3}
                                          // lg={2.5}
                                          // xl={width < 1900 ? 1 : 1}
                                          className={classes.quantity}
                                        >
                                          <TextField
                                            variant="outlined"
                                            fullWidth
                                            inputRef={quantityRef}
                                            disabled={!item.isNew}
                                            placeholder="Quantity"
                                            // label="Quantity"
                                            inputProps={{ maxLength: 10 }}
                                            size="small"
                                            value={
                                              item.quantity ? item.quantity : ""
                                            }
                                            name={`medications[${index}]`}
                                            onChange={(e, value) => {
                                              handleChangeQuantity(e, index);
                                              handleChange(e);
                                            }}
                                            id={`quantity_${index}`}
                                            error={
                                              item?.errors?.quantity &&
                                              item?.errors?.quantity
                                            }
                                            helperText={
                                              item?.errors?.quantity &&
                                              item?.errors?.quantity
                                            }
                                            onBlur={handleBlur}
                                            className={
                                              classes.rsTextFieldQuantity
                                            }
                                          />
                                        </Grid>

                                        <Grid
                                          display={"flex"}
                                          alignItems={"center"}
                                        >
                                          <Grid className={classes.rsbuttonPrn}>
                                            <FormGroup>
                                              <FormControlLabel
                                                className={classes.rsPrncheck}
                                                // label="Mark PRN"
                                                label="PRN"
                                                control={
                                                  // <>
                                                  //   {item?.changeable_prn ? (
                                                  //     <Button
                                                  //       variant="contained"
                                                  //       onClick={(e) => {
                                                  //         handleChangePRN(e, index);
                                                  //       }}
                                                  //     >
                                                  //       Mark not PRN
                                                  //     </Button>
                                                  //   ) : (
                                                  //     <Button
                                                  //       variant="outlined"
                                                  //       onClick={(e) => {
                                                  //         handleChangePRN(e, index);
                                                  //       }}
                                                  //     >
                                                  //       Mark PRN
                                                  //     </Button>
                                                  //   )}
                                                  //   <Box>
                                                  //     {item?.changeable_prn ? (
                                                  //       <Button
                                                  //         variant="contained"
                                                  //         onClick={(e) => {
                                                  //           handleChangePRN(e, index);
                                                  //         }}
                                                  //       >
                                                  //         PRN
                                                  //       </Button>
                                                  //     ) : (
                                                  //       <Button
                                                  //         variant="outlined"
                                                  //         onClick={(e) => {
                                                  //           handleChangePRN(e, index);
                                                  //         }}
                                                  //       >
                                                  //         Mark PRN
                                                  //       </Button>
                                                  //     )}
                                                  //   </Box>
                                                  // </>
                                                  <Checkbox
                                                    color="primary"
                                                    checked={
                                                      item?.changeable_prn
                                                        ? item?.changeable_prn ===
                                                          true
                                                        : false
                                                    }
                                                    onChange={(e, value) => {
                                                      handleChangePRN(e, index);
                                                    }}
                                                  />
                                                }
                                              />
                                            </FormGroup>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </>
                                  )}
                                </Grid>

                                {/* <Grid
                                display={"flex"}
                                justifyContent={"flex-start"}
                                alignItems={"center"}
                                // marginLeft={"10px"}
                                marginTop={"15px"}
                                marginBottom={"0px"}
                              >
                              
                              </Grid> */}
                              </Grid>
                              {/* <Grid item xs={12} className={classes.medicineHr}>
                              <Divider />
                            </Grid> */}
                            </>
                          );
                        })}
                      </Grid>
                    </Grid>
                  </Paper>
                  {/* </Grid> */}

                  {/* <Paper  className={classes.reRepeatOrder}>
                  <Typography variant="h3" medium color="secondary">
                    Medicine details
                  </Typography>
                  <Divider />
                  <Grid
                    container
                    columnSpacing={2.5}
                    rowSpacing={3}
                    className={classes.rsPatientGridOne}
                  >
                    <Grid item xs={12} className={classes.rsMediValue}>
                      <Table stickyHeader id="quantity">
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ width: "50%" }}>
                              <div style={{ display: "flex" }}>
                                DRUG{" "}
                                <div
                                  style={{ color: "red", marginLeft: "5px" }}
                                >
                                  *
                                </div>{" "}
                              </div>
                            </TableCell>
                            <TableCell style={{ width: "10%" }}>
                              QUANTITY
                            </TableCell>
                            <TableCell style={{ width: "0%" }}>PRN</TableCell>
                            <TableCell style={{ width: "0%" }}>
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-around"}
                              >
                                ORDER
                                <FormGroup style={{ marginLeft: "10px" }}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={checkAllAction}
                                        className={classes.orderCheckBox}
                                        onChange={(e, value) => {
                                          const isChecked = !checkAllAction;
                                          setCheckAllAction(isChecked);

                                          const _medications = medications?.map(
                                            (item) => {
                                              item.action = isChecked;
                                              return item;
                                            }
                                          );
                                          setMedications(_medications);
                                        }}
                                      />
                                    }
                                  />
                                </FormGroup>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {medications.map((item, index) => {
                            return (
                              <TableRow className={classes.tableBody}>
                                <TableCell>
                                  <DrugAutoComplete
                                    listOpen={listOpen}
                                    fullWidth
                                    disabled={!item.isNew}
                                    filterMedication={medications}
                                    className={classes.rsDrugAutoCompleteBox}
                                    value={item}
                                    onChange={(e, value) => {
                                      value = value
                                        ? {
                                            ...value,
                                            name: value?.label,
                                          }
                                        : value;
                                      delete value?.label;
                                      handleDrugChange(e, index, value);
                                      handleChange("drug", value);
                                      if (value !== null) {
                                        quantityRef.current.focus();
                                      }
                                    }}
                                    id={`name_${index}`}
                                    orderActionType={orderActionType}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                      <>
                                        <TextField
                                          {...params}
                                          inputRef={
                                            orderActionType === "orderCreate"
                                              ? medicationRef
                                              : ""
                                          }
                                          autoFocus={
                                            orderActionType === "orderCreate"
                                          }
                                          id={`name_${index}`}
                                          label="Drug Name"
                                          placeholder="Choose Drug"
                                          error={
                                            item?.errors?.name &&
                                            item?.errors?.name
                                          }
                                          helperText={
                                            item?.errors?.name &&
                                            item?.errors?.name
                                          }
                                        />
                                      </>
                                    )}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    variant="outlined"
                                    fullWidth
                                    inputRef={quantityRef}
                                    disabled={!item.isNew}
                                    placeholder="Quantity"
                                    label="Quantity"
                                    inputProps={{ maxLength: 10 }}
                                    size="small"
                                    value={item.quantity ? item.quantity : ""}
                                    name={`medications[${index}]`}
                                    onChange={(e, value) => {
                                      handleChangeQuantity(e, index);
                                      handleChange(e);
                                    }}
                                    id={`quantity_${index}`}
                                    error={
                                      item?.errors?.quantity &&
                                      item?.errors?.quantity
                                    }
                                    helperText={
                                      item?.errors?.quantity &&
                                      item?.errors?.quantity
                                    }
                                    onBlur={handleBlur}
                                    className={classes.rsTextField}
                                  />
                                </TableCell>
                                <TableCell className={classes.rsbuttonPrn}>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <>
                                          {item?.changeable_prn ? (
                                            <Button
                                              variant="contained"
                                              onClick={(e) => {
                                                handleChangePRN(e, index);
                                              }}
                                            >
                                              Mark not PRN
                                            </Button>
                                          ) : (
                                            <Button
                                              variant="outlined"
                                              onClick={(e) => {
                                                handleChangePRN(e, index);
                                              }}
                                            >
                                              Mark PRN
                                            </Button>
                                          )}
                                          <Box>
                                            {item?.changeable_prn ? (
                                              <Button
                                                variant="contained"
                                                onClick={(e) => {
                                                  handleChangePRN(e, index);
                                                }}
                                              >
                                                PRN
                                              </Button>
                                            ) : (
                                              <Button
                                                variant="outlined"
                                                onClick={(e) => {
                                                  handleChangePRN(e, index);
                                                }}
                                              >
                                                Mark PRN
                                              </Button>
                                            )}
                                          </Box>
                                        </>
                                      }
                                    />
                                  </FormGroup>
                                </TableCell>
                                <TableCell>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          color="primary"
                                          checked={
                                            item?.action ? item?.action : false
                                          }
                                          onChange={(e, value) => {
                                            handleChangeAction(e, index);
                                          }}
                                        />
                                      }
                                    />
                                  </FormGroup>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Grid>
                  </Grid>
                </Paper> */}
                </Grid>
                {/* <Grid item xs={12} sm={12} md={12} lg={12}> */}
                {/* <Paper elevation={0} className={classes.rsPatientMedicationBtn}>
                  <Grid
                    container
                    columnSpacing={2.5}
                    rowSpacing={3}
                    className={classes.rsPatientGridOne}
                  >
                    <Grid item xs={12}>
                      <Typography variant="h3" medium color="secondary">
                        Order Note
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        fullWidth
                        className={classes.textField}
                        variant="outlined"
                        size="small"
                        placeholder="Add Note"
                        name="notes"
                        id="outlined-adornment-weight"
                        aria-describedby="outlined-weight-helper-text"
                        value={values?.notes}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        error={touched?.notes && errors?.notes}
                        helperText={touched?.notes && errors?.notes}
                        onBlur={handleBlur}
                        inputProps={{
                          "aria-label": "weight",
                        }}
                      />
                    </Grid>
                  </Grid>
                </Paper> */}
                {/* </Grid> */}
              </>
            )}
        </Grid>
        {width < 900 &&
          showWholeForm &&
          !searchRepeatOrder?.loading &&
          !singleRepeatOrder?.loading && (
            <>
              <Grid
                container
                columnSpacing={2.5}
                rowSpacing={2}
                className={classes.submitSection}
              >
                {/* <Box display={"flex"} margin={"0 auto"} justifyContent={"center"}> */}
                {/* <Grid item xs={6} sm={6} md={6} lg={6}> */}
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  className={clsx("BtnGray", classes.rsPatientCancelBtn)}
                >
                  Cancel
                </Button>
                {/* </Grid> */}
                {/* <Grid item xs={6} sm={6} md={6} lg={6}> */}
                <Button
                  variant="contained"
                  type="submit"
                  className={classes.rsSubmittBtn}
                  disabled={
                    createRepeatOrderData?.loading ||
                    updateRepeatOrderData?.loading ||
                    singleRepeatOrder.loading
                  }
                  startIcon={
                    (createRepeatOrderData?.loading ||
                      updateRepeatOrderData?.loading) && (
                      <CircularProgress color="white" size="20px" />
                    )
                  }
                >
                  Submit
                </Button>
                {/* </Grid> */}
                {/* </Box> */}
              </Grid>
            </>
          )}
      </form>
      <DrugsDialog
        open={createDrug}
        setOpen={setCreateDrug}
        patient_id={selectedPatientInfo?.patient_id || selectedPatientInfo?.id}
        searchRepeatOrder={searchRepeatOrder}
        callBackOnSubmitPatientInfo={callBackOnSubmitPatientInfo}
        callBackOnCancelPatientInfo={callBackOnCancelPatientInfo}
      />
      <PRNSeleactionDialog
        title="Are you sure that the PRNs for the order are correct?"
        open={isOpenPRNConformation}
        setOpen={setIsOpenPRNConformation}
        createRepeatOrderData={createRepeatOrderData}
        updateRepeatOrderData={updateRepeatOrderData}
        singleRepeatOrder={singleRepeatOrder}
        onSubmit={finalSubmitForm}
      />
      <PateintCreateDialog
        open={isOpenNewPatientRepeatOrderPopup}
        setOpen={setIsOpenNewPatientRepeatOrderPopup}
        callBackOnSubmit={onSuccessOfSubmitPatientForm}
      />
      <MultiOrderConfirmationDialog
        open={isMultiOrder}
        setOpen={setIsMultiOrder}
        handleSubmit={handleSubmit}
        setCreateMultiOrder={setCreateMultiOrder}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  createRepeatOrderData: state.order.createRepeatOrderData,
  updateRepeatOrderData: state.order.updateRepeatOrderData,
  singleRepeatOrder: state.order.singleRepeatOrder,
  searchRepeatOrder: state.order.searchRepeatOrder,
});

const mapDispatchToProps = (dispatch) => ({
  createRepeatOrderAction: (payload) =>
    dispatch({ type: START_CREATE_REPEAT_ORDER, payload }),
  updateRepeatOrderAction: (id, payload) =>
    dispatch({ type: START_UPDATE_REPEAT_ORDER, id, payload }),
  resetRepeatOrderState: (key, payload) =>
    dispatch({ type: RESET_REPEAT_ORDER_STATE, key, payload }),
  getSingleRepeatOrderAction: (id) =>
    dispatch({ type: START_GET_SINGLE_REPEAT_ORDER, id }),
  getSearchRepeatOrderAction: (id) =>
    dispatch({ type: START_GET_SEARCH_REPEAT_ORDER, id }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderCreateAndUpdateMain);
